"use client";
import * as React from 'react';

export default function CardGridSkeleton({ count, responsive = true }: { count?: number; responsive?: boolean }) {
  const [n, setN] = React.useState<number>(count ?? 6);
  React.useEffect(() => {
    if (!responsive || typeof window === 'undefined' || typeof count === 'number') return;
    const compute = () => {
      try {
        const w = window.innerWidth || 0;
        // Roughly align with grid breakpoints: <md: 1 col → 4, md+: 3 cols → 9
        const next = w < 768 ? 4 : 9;
        setN(next);
      } catch { setN(6); }
    };
    compute();
    const on = () => compute();
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, [responsive, count]);

  const total = typeof count === 'number' ? count : n;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      {Array.from({ length: total }).map((_, i) => (
        <div key={i} className="border rounded-lg overflow-hidden">
          <div className="h-44 skeleton" />
          <div className="p-3">
            <div className="h-4 w-2/3 skeleton" />
          </div>
        </div>
      ))}
    </div>
  );
}
